$(document).ready( function() {
    initMapClick();
    if ($(window).width() < 768) {
        $('.map-section .map-bg').scrollLeft(150);
    }
});

$(window).resize( function() {
    if ($(window).width() < 768) {
        $('.map-section .map-bg').scrollLeft(150);
    }
});

function initMapClick() {
    $('.location-point').click( function() {
        $('.location-point').attr("data-clicked", "");
        $(this).attr("data-clicked", "active");
        $(this).attr("data-clicked", "active");
        var location = $(this).data('click');
        $('.map-info').hide();
        $(`.map-info.${location}`).show();
    })
}   